import React, { useState } from "react";
import {useParams} from "react-router";
import {
  DownLoadPortfolioReport,
  DownLoadPortfolioUserReport,
} from "../../../services/PortfolioApi";
import useAuth from "../../login/AuthContext";
import { ReportCheckboxes } from "../../../components/ReportCheckboxes";
import { Divider } from "../../../UI/Divider";
import { Grid } from "../../../UI/Grid";
import { Typography } from "../../../UI/Typography";
import { MatchingRoundStatusSelector } from "../../../components/MatchingRoundStatusSelector";
import DownloadCSVButton from "../../../common/component/DownloadCSVButton";

const initialState: Record<string, any> = {
    matchingRoundStatuses: [],
    userStatus: {
      title: "Select User Status",
      selection: 0,
    },
    registeredStatus: {
      title: "Selected Registration Status",
      selection: null,
    },
    checkboxes: {
      includeQuickJoinInfo: false,
      includeRegistrationInfo: false,
      includeSocialAccountsInfo: false,
      includeLifestyleQuestionInfo: false
    },
  };
  

export const PortfolioDetailedReport: React.FC = () => {
  const [state, setState] = useState(initialState);
  const { getAuthToken } = useAuth();
  const { portfolioId } = useParams<{ portfolioId: string }>();

  const handleCheckboxSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState({
   ...state,
   checkboxes: {
    ...state.checkboxes,
    [e.target.name]: e.target.checked,
   }
    });
  };

  const handleStatusSelection = (selection: any[]) => {
    const newState = {
      ...state,
      matchingRoundStatuses: selection.map(x => (x.value)),
    };
    setState(newState);
  };

  const getRequestBody = () => { 
    const { subnetwork, matchingRoundStatuses, unitType, userStatus, registeredStatus, checkboxes } = state;
    return {
      matchingRoundStatuses,
      subnetwork,
      unitType,
      userStatus,
      registeredStatus,
      ...checkboxes
    };
  };


  const handlePortfolioReportDownload = async () => {
    return DownLoadPortfolioReport(portfolioId, {
      portfolioId: portfolioId,
      reportType: "ALL_ACTIVE"
    }, await getAuthToken());
  };

  const handlePortfolioUserReportDownload = async () => {
    return DownLoadPortfolioUserReport(portfolioId, getRequestBody(), await getAuthToken());
  };

  return (
    <Grid container>
      <Grid container spacing={2} mt={3} ml={1}>
        <Typography variant="h5" fontWeight={400}>
          Porfolio User Report
        </Typography>
      </Grid>
      <Grid container spacing={2} mt={1}>
        <ReportCheckboxes handleCheckboxSelection={handleCheckboxSelection} checkboxes={state.checkboxes}/>
      </Grid>
      <Grid container spacing={2} mt={0.5} mb={3}>

        <Grid item>
          <MatchingRoundStatusSelector
            value={state.userStatus.matchingRoundStatuses}
            onChange={handleStatusSelection}
            isMulti
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item>
          <DownloadCSVButton
            title="Download Portfolio User Report"
            apiCall={handlePortfolioUserReportDownload}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={3} mb={4} ml={1}>
        <Typography variant="h5" fontWeight={400}>
          Porfolio Report
        </Typography>
      </Grid>
      <Grid container spacing={2}>
      <Grid item>
          <DownloadCSVButton
            title="Download Portfolio Report"
            apiCall={handlePortfolioReportDownload}
            type="csv"
          />
        </Grid>
      </Grid>
        
    </Grid>
  );
};